export default [
  {
    type: 'md-list',
    name: '投资偏好',
    value: [
      {
        type: 'tag',
        name: '投资阶段',
        ref: 'stage',
        // value: ['种子', '天使轮', 'Pre-A', 'A轮']
        value: []
      },
      {
        type: 'tag',
        name: '投资领域',
        ref: 'industry',
        // value: ['金融', '电商', 'O2O', '文化娱乐']
        value: []
      },
      {
        type: 'range',
        name: '单个项目投资金额',
        unit: 10000,
        // value: [1000000, 5000000]
        value: []
      }
    ]
  },
  {
    type: 'md-case',
    name: '投资案例',
    value: [
      // {
      //   type: 'media',
      //   name: '犀牛故事',
      //   value: '犀牛故事”是一个前所未有的故事分享平台。为想要读点好东西和爱分享的人细致打造',
      //   label: '读书社区'
      // },
      // {
      //   type: 'media',
      //   name: '笨鸟社交',
      //   value: '笨鸟社交立足社交媒体云计算，秉承以“数据驱动营销，社交改变未来”的产品理念，在社交时代为全球用户 提供全新的数字行销解决方案；',
      //   label: '互动商务社交'
      // }
    ]
  }
  // {
  //   type: 'md-talk',
  //   name: '公开提问',
  //   value: [
  //     {
  //       type: 'qa',
  //       q: {
  //         createdAt: '12月02日',
  //         desc: '你好，王总！我想问下新开设的公号如何实现冷启动，完成粉丝积累？阅读量一直上不去，到底是 哪里出了问题？我将整合自己10多年新媒'
  //       },
  //       a: {
  //         createdAt: '12月02日',
  //         name: '王志伟',
  //         title: '坚果资本合伙人',
  //         desc: '那么多社区O2O企业非死即伤，如果仅是几家公司的问题，那可以说是创始人的问题，但近乎全 盘沦陷局面，则是市场本身存在某些问题。'
  //       }
  //     }
  //   ]
  // }
]



// WEBPACK FOOTER //
// ./src/page/defaultMdList.js